import React from 'react';
import { Layout } from 'antd';

const { Content } = Layout;

const AuthLayout = ({ children }) => {
  return (
    <Layout className="auth-layout">
      <Content className="login-container">
        {children}
      </Content>
    </Layout>
  );
};

export default AuthLayout;
